import { cx } from 'class-variance-authority'
import React, { forwardRef } from 'react'

import { Text } from '../Text/Text'

import styles from './Validation.module.scss'

export type ValidationVariant = 'error' | 'success' | 'default'

interface ValidationProps {
  children: React.ReactNode
  className?: string
  variant?: ValidationVariant
  id?: string
  'aria-live'?: 'assertive' | 'polite'
  role?: 'alert' | 'status'
}

export const Validation = forwardRef<HTMLSpanElement, ValidationProps>(
  (
    {
      className,
      children,
      variant = 'error',
      id,
      'aria-live': ariaLive,
      role,
      ...props
    },
    ref
  ) => {
    return (
      <Text
        aria-live={ariaLive ?? (variant === 'error' ? 'assertive' : 'polite')}
        as="span"
        className={cx(
          styles.Validation,
          styles[`Validation${variant}`],
          className
        )}
        color={
          variant === 'error' ? 'red' : variant === 'success' ? 'green' : 'gray'
        }
        id={id}
        ref={ref}
        role={role ?? (variant === 'error' ? 'alert' : 'status')}
        {...props}
      >
        {children}
      </Text>
    )
  }
)

Validation.displayName = 'Validation'
